export default {
  methods: {
    stripeKey() {
      let businessUnitId = this.company.business_unit.id;
      return process.env['VUE_APP_STRIPE_KEY_' + businessUnitId];
    }
  }
}
